var _slicedToArray = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 * Dependencies
 */
var base64url = require('base64url');

var JWA = require('./JWA');

var _require = require('../errors'),
    DataError = _require.DataError;

var JOSEHeader = require('./JOSEHeader');
/**
 * JWS
 */


var JWS = /*#__PURE__*/function () {
  "use strict";

  function JWS() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, JWS);

    // compact
    this.header = new JOSEHeader(data.header);
    this.payload = data.payload || {};
    this.signature = data.signature; // flattened

    this.protected = data.protected; // JSON serialization

    this.signatures = data.signatures;
    this.verified = false;
  }
  /**
   * sign
   *
   * @description
   * Encode a JWT instance
   *
   * @param {Object} token
   * @returns {Promise}
   */


  _createClass(JWS, null, [{
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token) {
        var payload, key, alg, header, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payload = base64url(JSON.stringify(token.payload)); // compact serialization

                if (!(token.serialization === 'compact')) {
                  _context.next = 6;
                  break;
                }

                key = token.key, alg = token.header.alg;
                header = base64url(JSON.stringify(token.header));
                data = "".concat(header, ".").concat(payload);
                return _context.abrupt("return", JWA.sign(alg, key, data).then(function (signature) {
                  return "".concat(data, ".").concat(signature);
                }));

              case 6:
                // JSON serialization
                if (token.serialization === 'json') {} // Flattened serialization


                if (token.serialization === 'flattened') {}

                return _context.abrupt("return", Promise.reject(new DataError('Unsupported serialization')));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sign(_x) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
    /**
     * verify
     */

  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(jwt) {
        var key, signature, alg, _jwt$segments, header, payload, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // multiple signatures
                if (jwt.signatures) {// ...
                }

                key = jwt.key, signature = jwt.signature, alg = jwt.header.alg; // one signature

                if (!jwt.signature) {
                  _context2.next = 8;
                  break;
                }

                _jwt$segments = _slicedToArray(jwt.segments, 2), header = _jwt$segments[0], payload = _jwt$segments[1];
                data = "".concat(header, ".").concat(payload);

                if (!(alg === 'none')) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", Promise.reject(new DataError('Signature provided to verify with alg: none')));

              case 7:
                return _context2.abrupt("return", JWA.verify(alg, key, signature, data).then(function (verified) {
                  jwt.verified = verified;
                  return verified;
                }));

              case 8:
                if (!(alg === 'none')) {
                  _context2.next = 14;
                  break;
                }

                if (!(!key && !signature)) {
                  _context2.next = 12;
                  break;
                }

                jwt.verified = true;
                return _context2.abrupt("return", Promise.resolve(true));

              case 12:
                if (!key) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("return", Promise.reject(new DataError('Key provided to verify signature with alg: none')));

              case 14:
                return _context2.abrupt("return", Promise.reject(new DataError('Missing signature(s)')));

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function verify(_x2) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }]);

  return JWS;
}();
/**
 * Export
 */


module.exports = JWS;